export default __webpack_public_path__ + "static/logo32-c99b020971e35c63d8ca62c5fbb9f766.png";